import { render, staticRenderFns } from "./ProductListWrapper.vue?vue&type=template&id=660ae4e6&scoped=true&"
import script from "./ProductListWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProductListWrapper.vue?vue&type=style&index=0&id=660ae4e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660ae4e6",
  null
  
)

export default component.exports